<template>
	<div class="login-content__body">
		<div class="row">
			<div class="col-sm-12">
				<div class="login-content__body-description">
					<h2>{{$t('login.description')}}</h2>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-12 col-md-12 col-lg-12">
				<div class="login">
					<form action="https://masterway-dev-api.docura.net/login" method="post" @submit.prevent="login">

						<input class="textInput login_input-top-radius" name="username" type="text"
							   id="login_input-name" :placeholder="$t('email')" v-model="username">
						<div class="login_change_password">
							<a class="auth-link" href="/reset-password?lang=en">{{ $t('login.change.password') }}</a>
						</div>
						<input class="textInput login_input-bottom-radius" name="password"
							   type="password" id="login_input-pass" :placeholder="$t('password')" v-model="password">
						<button type="submit" class="login_button-login">Login</button>

						<p id="login_error" v-if="error"
						   style="margin: 0; font-size: 14px; color:red;">
							{{error}}
						</p>

						<div class="login_signup">
							<div class="row">
								<div class="col-xs-7">
									<a class="auth-link" href="/signup">{{ $t('have.on.account') }}</a>
								</div>
								<div class="col-xs-5">
									<div class="login-content__switch-lang">
										<Languages/>
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { AUTH_REQUEST } from 'actions/authentication'
import Languages from 'components/languages-switch/Languages'

export default {
	name: 'login',
	metaInfo: {
		title: 'Login'
	},
	data () {
		return {
			username: null,
			password: null,
			error: null
		}
	},
	components: {
		Languages
	},
	methods: {
		login: function () {
			this.validate().then((resp) => {
				if (resp) {
					const { username, password } = this
					this.$store.dispatch(AUTH_REQUEST, {
						username,
						password
					})
					.then(() => {
						this.$router.push('/')
					}).catch(() => {
						this.error = 'error'
					})
				}
			})
		},
		validate: async function () {
			if (this.username && this.password) {
				return true
			}
			this.error = null

			if (!this.username) {
				this.error = this.$t('email_required')
			}
			if (!this.password) {
				this.error = this.$t('password_required')
			}
			return false
		}
	}
}
</script>
